module.exports = __webpack_public_path__ + "static/img/320x100-premier_.8349ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/leagues/320x100-premier_.jpg
// module id = /U3c
// module chunks = 2